import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { WatchNowOfferFragmentDoc } from '../../../../pages/graphql/fragments/WatchNowOffer.fragment';
export type GetSrPlacementMutationVariables = Types.Exact<{
	input: Types.GetAdInput;
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	format?: Types.InputMaybe<Types.ImageFormat>;
	platform?: Types.Platform;
	backdropProfile?: Types.InputMaybe<Types.BackdropProfile>;
}>;

export type GetSrPlacementMutation = {
	__typename?: 'Mutation';
	getAd: {
		__typename?: 'GetAdPayload';
		bidID?: string | null;
		ads?: Array<
			| { __typename?: 'CreativeFreeTrialContent' }
			| { __typename?: 'CreativeGAMContent' }
			| { __typename?: 'CreativeGenericContent' }
			| { __typename?: 'CreativeQTVContent' }
			| { __typename?: 'CreativeSQTVContent' }
			| {
					__typename?: 'CreativeSRContent';
					bidID: string;
					holdoutGroup: boolean;
					campaign?: {
						__typename: 'SponsoredRecommendationCampaign';
						name: string;
						countdownTimer?: any | null;
						creativeType?: Types.CreativeType | null;
						disclaimerText?: string | null;
						hideDetailPageButton: boolean;
						hideImdbScore?: boolean | null;
						hideJwScore?: boolean | null;
						hideRatings: boolean;
						hideContent?: boolean | null;
						posterOverride?: string | null;
						playSRVideoAsGif?: boolean | null;
						promotionalImageUrl?: string | null;
						promotionalTitle?: string | null;
						promotionalText?: string | null;
						promotionalProviderLogo?: string | null;
						promotionalProviderWideLogo?: string | null;
						tags?: Array<string> | null;
						bannerText?: string | null;
						watchNowLabel?: string | null;
						backgroundImages?: Array<{
							__typename?: 'BackgroundImage';
							imageURL: string;
							size: Types.BackgroundImageSize;
						} | null> | null;
						externalTrackers: Array<{
							__typename?: 'ExternalTracker';
							type: Types.ExternalTrackerType;
							data: string;
						}>;
						promotionalVideo?: { __typename?: 'PromotionalVideo'; url: string } | null;
						watchNowOffer: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						};
						nodeOverrides: Array<{
							__typename?: 'NodeOverride';
							nodeId: string;
							promotionalImageUrl?: string | null;
							watchNowOffer?: { __typename?: 'Offer'; standardWebURL?: string | null } | null;
						}>;
						node:
							| { __typename: 'Article'; nodeId: string }
							| { __typename: 'Author'; nodeId: string }
							| { __typename: 'Bundle'; nodeId: string }
							| { __typename: 'Device'; nodeId: string }
							| { __typename: 'Episode'; nodeId: string }
							| {
									__typename: 'GenericTitleList';
									id: string;
									type: Types.GenericTitleListType;
									nodeId: string;
									followedlistEntry?: {
										__typename?: 'FollowedListEntry';
										createdAt: any;
										name: string;
									} | null;
									content: {
										__typename?: 'GenericTitleListContent';
										name: string;
										visibility: Types.GenericTitleListVisibility;
									};
									titles: {
										__typename?: 'GenericTitleListConnection';
										totalCount: number;
										edges?: Array<{
											__typename?: 'GenericTitleListEdge';
											cursor: string;
											node:
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														content: {
															__typename?: 'MovieContent';
															fullPath: string;
															posterUrl?: string | null;
															title: string;
															originalReleaseYear?: number | null;
															isReleased: boolean;
															credits: Array<{
																__typename?: 'Credit';
																role: Types.CreditRole;
																name: string;
																characterName?: string | null;
																personId: number;
															}>;
															interactions: {
																__typename?: 'InteractionAttributes';
																dislikelistAdditions: number;
																likelistAdditions: number;
																votesNumber: number;
															};
															scoring: {
																__typename?: 'Scoring';
																imdbVotes?: number | null;
																imdbScore?: number | null;
																tomatoMeter?: number | null;
																certifiedFresh?: boolean | null;
																jwRating?: number | null;
															};
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															fullPath: string;
															posterUrl?: string | null;
															title: string;
															originalReleaseYear?: number | null;
															isReleased: boolean;
															interactions: {
																__typename?: 'InteractionAttributes';
																dislikelistAdditions: number;
																likelistAdditions: number;
																votesNumber: number;
															};
															scoring: {
																__typename?: 'Scoring';
																imdbVotes?: number | null;
																imdbScore?: number | null;
																tomatoMeter?: number | null;
																certifiedFresh?: boolean | null;
																jwRating?: number | null;
															};
														};
														show: {
															__typename: 'Show';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
														};
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														content: {
															__typename?: 'ShowContent';
															fullPath: string;
															posterUrl?: string | null;
															title: string;
															originalReleaseYear?: number | null;
															isReleased: boolean;
															credits: Array<{
																__typename?: 'Credit';
																role: Types.CreditRole;
																name: string;
																characterName?: string | null;
																personId: number;
															}>;
															interactions: {
																__typename?: 'InteractionAttributes';
																dislikelistAdditions: number;
																likelistAdditions: number;
																votesNumber: number;
															};
															scoring: {
																__typename?: 'Scoring';
																imdbVotes?: number | null;
																imdbScore?: number | null;
																tomatoMeter?: number | null;
																certifiedFresh?: boolean | null;
																jwRating?: number | null;
															};
														};
												  };
										}> | null;
									};
							  }
							| { __typename: 'Genre'; nodeId: string }
							| { __typename: 'HomePage'; nodeId: string }
							| {
									__typename: 'Movie';
									objectId: number;
									objectType: Types.ObjectType;
									nodeId: string;
									content: {
										__typename?: 'MovieContent';
										fullPath: string;
										posterUrl?: string | null;
										title: string;
										originalReleaseYear?: number | null;
										isReleased: boolean;
										credits: Array<{
											__typename?: 'Credit';
											role: Types.CreditRole;
											name: string;
											characterName?: string | null;
											personId: number;
										}>;
										interactions: {
											__typename?: 'InteractionAttributes';
											dislikelistAdditions: number;
											likelistAdditions: number;
											votesNumber: number;
										};
										scoring: {
											__typename?: 'Scoring';
											imdbScore?: number | null;
											jwRating?: number | null;
										};
										genres: Array<{ __typename?: 'Genre'; shortName: string; translation: string }>;
										externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
									};
									offers: Array<{
										__typename?: 'Offer';
										monetizationType: Types.MonetizationType;
										presentationType: Types.PresentationType;
										id: string;
										package: { __typename?: 'Package'; id: string; packageId: number };
									}>;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							  }
							| { __typename: 'MultiStepSportEvent'; nodeId: string }
							| { __typename: 'Offer'; nodeId: string }
							| { __typename: 'OfferHistory'; nodeId: string }
							| { __typename: 'Package'; nodeId: string }
							| { __typename: 'Page'; nodeId: string }
							| { __typename: 'Person'; nodeId: string }
							| { __typename: 'PressRelease'; nodeId: string }
							| { __typename: 'ProfileV2'; nodeId: string }
							| {
									__typename: 'Season';
									objectId: number;
									objectType: Types.ObjectType;
									nodeId: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
										title: string;
										originalReleaseYear?: number | null;
										isReleased: boolean;
										seasonNumber: number;
										interactions: {
											__typename?: 'InteractionAttributes';
											dislikelistAdditions: number;
											likelistAdditions: number;
											votesNumber: number;
										};
										scoring: {
											__typename?: 'Scoring';
											imdbScore?: number | null;
											jwRating?: number | null;
										};
										genres: Array<{ __typename?: 'Genre'; shortName: string; translation: string }>;
										externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
									};
									offers: Array<{
										__typename?: 'Offer';
										monetizationType: Types.MonetizationType;
										presentationType: Types.PresentationType;
										id: string;
										package: { __typename?: 'Package'; id: string; packageId: number };
									}>;
									show: {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: { __typename?: 'ShowContent'; originalTitle: string };
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									};
							  }
							| {
									__typename: 'Show';
									objectId: number;
									objectType: Types.ObjectType;
									nodeId: string;
									content: {
										__typename?: 'ShowContent';
										fullPath: string;
										posterUrl?: string | null;
										title: string;
										originalReleaseYear?: number | null;
										isReleased: boolean;
										credits: Array<{
											__typename?: 'Credit';
											role: Types.CreditRole;
											name: string;
											characterName?: string | null;
											personId: number;
										}>;
										interactions: {
											__typename?: 'InteractionAttributes';
											dislikelistAdditions: number;
											likelistAdditions: number;
											votesNumber: number;
										};
										scoring: {
											__typename?: 'Scoring';
											imdbScore?: number | null;
											jwRating?: number | null;
										};
										genres: Array<{ __typename?: 'Genre'; shortName: string; translation: string }>;
										externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
									};
									offers: Array<{
										__typename?: 'Offer';
										monetizationType: Types.MonetizationType;
										presentationType: Types.PresentationType;
										id: string;
										package: { __typename?: 'Package'; id: string; packageId: number };
									}>;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number };
							  }
							| { __typename: 'SingleStepSportEvent'; nodeId: string }
							| { __typename: 'SportCompetitionV2'; nodeId: string }
							| { __typename: 'SportCompetitorV2'; nodeId: string }
							| { __typename: 'SportMatch'; nodeId: string }
							| { __typename: 'Url'; nodeId: string }
							| { __typename: 'UserProviderSubscription'; nodeId: string };
					} | null;
			  }
			| { __typename?: 'CreativeSwiperContent' }
		> | null;
	};
};

export const GetSrPlacementDocument = gql`
	mutation GetSrPlacement(
		$input: GetAdInput!
		$country: Country!
		$language: Language!
		$format: ImageFormat
		$platform: Platform! = WEB
		$backdropProfile: BackdropProfile
	) {
		getAd(input: $input) {
			ads {
				... on CreativeSRContent {
					bidID
					holdoutGroup
					campaign {
						__typename
						name
						backgroundImages {
							imageURL
							size
						}
						countdownTimer
						creativeType
						disclaimerText
						externalTrackers {
							type
							data
						}
						hideDetailPageButton
						hideImdbScore
						hideJwScore
						hideRatings
						hideContent
						posterOverride
						playSRVideoAsGif
						promotionalImageUrl
						promotionalVideo {
							url
						}
						promotionalTitle
						promotionalText
						promotionalProviderLogo
						promotionalProviderWideLogo
						tags
						bannerText
						watchNowLabel
						watchNowOffer {
							...WatchNowOffer
						}
						nodeOverrides {
							nodeId
							promotionalImageUrl
							watchNowOffer {
								standardWebURL
							}
						}
						node {
							nodeId: id
							__typename
							... on MovieOrShowOrSeason {
								content(country: $country, language: $language) {
									fullPath
									posterUrl
									title
									originalReleaseYear
									scoring {
										imdbScore
										jwRating
									}
									genres {
										shortName
										translation(language: $language)
									}
									externalIds {
										imdbId
									}
									backdrops(format: $format, profile: $backdropProfile) {
										backdropUrl
									}
									isReleased
									... on MovieOrShowContent {
										credits {
											role
											name
											characterName
											personId
										}
										interactions {
											dislikelistAdditions
											likelistAdditions
											votesNumber
										}
									}
									... on SeasonContent {
										interactions {
											dislikelistAdditions
											likelistAdditions
											votesNumber
										}
									}
								}
								objectId
								objectType
								offers(country: $country, platform: $platform, filter: { preAffiliate: true }) {
									monetizationType
									presentationType
									package {
										id
										packageId
									}
									id
								}
							}
							... on MovieOrShow {
								watchlistEntryV2 {
									createdAt
								}
							}
							... on Show {
								seenState(country: $country) {
									seenEpisodeCount
								}
							}
							... on Season {
								content(country: $country, language: $language) {
									seasonNumber
								}
								show {
									__typename
									id
									objectId
									objectType
									content(country: $country, language: $language) {
										originalTitle
									}
									watchlistEntryV2 {
										createdAt
									}
								}
							}
							... on GenericTitleList {
								followedlistEntry {
									createdAt
									name
								}
								id
								type
								content(country: $country, language: $language) {
									name
									visibility
								}
								titles(country: $country, first: 40) {
									totalCount
									edges {
										cursor
										node: nodeV2 {
											__typename
											id
											objectId
											objectType
											content(country: $country, language: $language) {
												fullPath
												posterUrl
												title
												originalReleaseYear
												scoring {
													imdbVotes
													imdbScore
													tomatoMeter
													certifiedFresh
													jwRating
												}
												isReleased
												... on MovieOrShowContent {
													credits {
														role
														name
														characterName
														personId
													}
													interactions {
														dislikelistAdditions
														likelistAdditions
														votesNumber
													}
												}
												... on SeasonContent {
													interactions {
														dislikelistAdditions
														likelistAdditions
														votesNumber
													}
												}
											}
											... on Season {
												content(country: $country, language: $language) {
													seasonNumber
												}
												show {
													__typename
													id
													objectId
													objectType
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
			bidID
		}
	}
	${WatchNowOfferFragmentDoc}
`;
